import { BookDetailPopupComponent } from './booking-detail-popup.component';
import { FluVaccineComponent } from './flu-vaccine.component';
import { FluVaccineRoutingModule } from './flu-vaccine.routing';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { ScheduleModule } from 'primeng/primeng';
@NgModule({
    declarations: [
      FluVaccineComponent,
      BookDetailPopupComponent
    ],
    imports: [FluVaccineRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule, ScheduleModule],
    entryComponents: [
      BookDetailPopupComponent
    ],
    providers: [],
    bootstrap: []
})
export class FluVaccineModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/flu-vaccine/flu-vaccine.module.ts